/**
 * Versión y notas de la app. Subí APP_VERSION cada vez que liberes cambios
 * y sumá una entrada arriba de todo en CHANGELOG.
 */

export const APP_VERSION = '1.4.0';

export interface PedidoResuelto {
  pedido: string; // lo que pidieron, en sus palabras
  hicimos: string; // cómo se resolvió
}

export interface ReleaseNote {
  version: string;
  fecha: string; // DD/MM/YYYY
  titulo: string;
  cambios?: string[];
  pedidos?: PedidoResuelto[]; // formato "Pidieron → Hicimos"
}

export const CHANGELOG: ReleaseNote[] = [
  {
    version: '1.4.0',
    fecha: '26/06/2026',
    titulo: 'Control y trazabilidad de stock',
    pedidos: [
      {
        pedido: 'Quiero ver el historial del stock: con cuánto se creó un producto, cuándo se repuso, cuándo se vendió o usó.',
        hicimos: 'Cada producto de Petshop, Farmacia e Insumos tiene un botón de reloj 🕐. Ahí ves todo lo que le pasó al stock: creación, reposición, venta, uso y anulación — con fecha, cantidad, con cuánto quedó y quién lo hizo.',
      },
      {
        pedido: 'Que una vez hecha la venta del petshop no se pueda cambiar el método de pago.',
        hicimos: 'El método de pago queda fijo apenas se registra la venta. Si hubo un error, se anula la venta y se vuelve a cargar (así queda todo con control).',
      },
      {
        pedido: 'Poder anular una venta o un uso que se registró por error, que devuelva el stock y no quede como plata que no entró.',
        hicimos: 'Botón "Anular" en Petshop, Farmacia e Insumos: devuelve el stock, quita el ingreso y deja registrado el motivo, quién y cuándo (no se borra, queda el rastro). Cualquiera puede anular.',
      },
    ],
  },
  {
    version: '1.3.1',
    fecha: '18/06/2026',
    titulo: 'Arreglos en Solicitudes',
    pedidos: [
      {
        pedido: 'Una doctora hizo un pedido y salió a nombre de otra.',
        hicimos: 'Ahora el "Pedido por" es quien envía la solicitud, no quien dejó armado el borrador del área. Corregimos también los pedidos que habían quedado mal.',
      },
      {
        pedido: 'Si toco "Empezar lista" y cancelo sin agregar nada, no debería quedar una lista vacía dando vueltas.',
        hicimos: 'La lista recién se crea cuando agregás el primer ítem. Si cancelás sin nada, no queda ningún borrador fantasma.',
      },
    ],
  },
  {
    version: '1.3.0',
    fecha: '11/06/2026',
    titulo: 'Jaulas, petshop y arreglos',
    pedidos: [
      {
        pedido: 'Necesitamos llevar las jaulas que prestamos: a quién, hasta cuándo, con foto, y que avise cuando vence.',
        hicimos: 'Nuevo módulo "Jaulas": cada jaula con foto, color y tamaño; se presta anotando cliente y celular (con botón de WhatsApp), desde y hasta; aviso cuando una vence; descripción/estado y garantía; e historial de préstamos con Excel y PDF.',
      },
      {
        pedido: 'Los gastos salen con la fecha y hora equivocadas.',
        hicimos: 'Corregimos la zona horaria: ahora la fecha y la hora son las reales de cuando se registró.',
      },
      {
        pedido: 'Quiero evaluar las ventas del petshop por período, no solo del mes.',
        hicimos: 'Botones rápidos Hoy/Ayer/Semana/Mes/Año + rango de fechas, mostrando la lista de ventas y con exportación a Excel.',
      },
      {
        pedido: 'Que no se pueda vender del petshop algo que no tiene stock.',
        hicimos: 'La venta descuenta el stock automáticamente y no deja vender si no alcanza.',
      },
    ],
  },
  {
    version: '1.2.0',
    fecha: '19/05/2026',
    titulo: 'Pagos, solicitudes y estadísticas',
    cambios: [
      'Gastos: opción "pendiente de pago" que no suma al total hasta marcarlo pagado.',
      'Gastos: adjuntar comprobante o recibo a cada pago.',
      'Gastos: filtros por proveedor, estado de pago y fechas (automáticos).',
      'Gastos: formulario rediseñado con monto destacado y fecha junto al método de pago.',
      'Solicitudes: recepción ahora puede pedir productos de Farmacia.',
      'Solicitudes: entrega parcial — entregás parte y el resto queda pendiente.',
      'Solicitudes: buscador de productos al armar el pedido + botón "Entregar directo".',
      'Solicitudes: filtros por área y fecha para la admin.',
      'Inventario: botones Usar/Salida y Avisar siempre en su lugar; gris cuando no hay stock.',
      'Inventario: el aviso de reposición salta cuando el stock está bajo, no solo en cero.',
      'Estadísticas (nuevo): gráficas de gastos, categorías, proveedores, método de pago y petshops.',
      'Doctora: se quitó el botón de WhatsApp y Archivos clínicos de su menú.',
    ],
  },
  {
    version: '1.1.0',
    fecha: '19/05/2026',
    titulo: 'Formularios, petshops y proveedores',
    cambios: [
      'Nuevo módulo Formularios: stock de papeles preimpresos (castración, vacuna, autorizaciones).',
      'Petshops: resumen diario y mensual para el cierre de caja.',
      'Petshops: venta tipo carrito con varios productos y cantidades.',
      'Proveedores: horario de atención y días que no atienden.',
      'Solicitudes por área con borrador compartido entre doctoras.',
      'Tablas rediseñadas con columnas más claras y stock visible.',
    ],
  },
  {
    version: '1.0.0',
    fecha: '13/05/2026',
    titulo: 'Primera versión',
    cambios: [
      'Inventario de Farmacia e Insumos internos.',
      'Gastos de la clínica.',
      'Petshops Danna y Bruno con catálogo y ventas.',
      'Gestión de proveedores y usuarios por rol.',
    ],
  },
];
